import { render, staticRenderFns } from "./DiastrbutionAdmin.vue?vue&type=template&id=5a16924c&scoped=true&"
import script from "./DiastrbutionAdmin.vue?vue&type=script&lang=js&"
export * from "./DiastrbutionAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DiastrbutionAdmin.vue?vue&type=style&index=0&id=5a16924c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16924c",
  null
  
)

export default component.exports